// frontend/user/src/_lib/file-route.ts
// 文件行点击 → 目标页路由的单一裁决点。
//
// 2026-05-31 按归属拆分(替代旧「/preview 与 /file 合并」):
//   - mode='detail'(默认,自己的文件):folder → /folders/:id(tC8FY);其余 → /file/:id
//       (DetailPage 按 mime 渲染 zkY66 图 / kENKt 视频 / qCOtS 音频 / pKcdM 其他 — owner 动作)
//   - mode='preview'(别人的文件):folder → /folders/:id;其余 → /preview/:id
//       (PreviewPage 按 mime 渲染 q5D4P 图 / AGXin 视频 / Qk72B 音频 / AFxaz 其他 — 社交/转存)
//
// 入口判定(D1,见 spec 2026-05-31-…-design.md):文件页/文件夹/搜索我的文件用 detail;
// 首页公开流 / 资源包预览页文件行用 preview。
// 复用 components/file-icon.tsx 的 fileKind() 归一(type → mime → 文件名后缀降级)。

import { fileKind } from '../components/file-icon'

/** fileOpenHref 入参:只需类型判定所需字段(对齐 offline-cache FileRow 子集)。 */
export type FileNavInput = {
  id: string
  type?: string | null
  mime_type?: string | null
  name?: string | null
}

/** 路由模式:detail = 自己的文件(/file 详情);preview = 别人的文件(/preview 预览)。 */
export type FileOpenMode = 'detail' | 'preview'

/**
 * 解析文件行点击后的目标 hash 路由(不含 `#`,交给 react-router navigate)。
 * 纯函数,无副作用 — 便于在多处列表(bi8Au / tC8FY / k9NLf / 资源包预览)复用并单测。
 *
 * @param opts.mode 'detail'(默认)→ /file/:id;'preview' → /preview/:id。文件夹不分模式,恒 /folders/:id。
 */
export function fileOpenHref(file: FileNavInput, opts?: { mode?: FileOpenMode }): string {
  const kind = fileKind(file.type, { mimeType: file.mime_type, name: file.name })
  if (kind === 'folder') return `/folders/${file.id}`
  const mode = opts?.mode ?? 'detail'
  return mode === 'preview' ? `/preview/${file.id}` : `/file/${file.id}`
}
